import CompaniesRequest from "../ws/CompaniesRequest";

export const COMPANIES_UPDATE = 'companies-update';

export const getCompanies = (page = 1, search = '') => (dispatch) => {

  new CompaniesRequest(page, search)
    .onSuccess(response => {
      // Enviamos los datos a redux
      dispatch({
        type: COMPANIES_UPDATE,
        payload: response,
      });
    })
    .execute();
};



// WEBPACK FOOTER //
// ./src/app/company/actions/companyActions.js